'use client';
import {
  useNavigationStore,
  useTrackNavigation,
} from '@/hooks/useNavigationStore';
import Link from 'next/link';
import NavArrow from '@/assets/icon/triangle-right-icon.svg';
import { SupportedLanguages } from '@/types/globals';

interface EventPageClientProps {
  basePath: string;
  locale: SupportedLanguages;
  text: {
    backToEvents: string;
    backToCalendar: string;
  };
}

export function EventPageClient({ basePath, text }: EventPageClientProps) {
  useTrackNavigation();
  const { previousPath } = useNavigationStore();
  const isFromCalendar = previousPath?.includes('/calendar');

  return (
    <div className="mb-8">
      <Link
        href={isFromCalendar ? `${basePath}/calendar` : basePath}
        className="group font-source-sans-pro text-qf-purple inline-flex items-center gap-2"
      >
        <NavArrow className="rotate-180 transition-transform group-hover:-translate-x-1" />
        <span>{isFromCalendar ? text.backToCalendar : text.backToEvents}</span>
      </Link>
    </div>
  );
}
